import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import urlSet from '@/requests/url'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  // let url = '/api/v1/user/getCustomerByIp?type=register'
  //     this.$http({
  //       url: url,
  //       method: 'GET',
  //     }).then((res) => {
  //       if (res.cxajaxrc == 0) {
  //         this.msg = res.cxajaxerrmsg
  //       }
  //     })
  const personalPaths = ['/MyWorkbench', '/MyRelation', '/MyPassword', '/MyProfile']
  const userId = localStorage.getItem('userruid')
  // 如果前往页面为个人中心而且未登录则重定向到首页
  if (personalPaths.includes(to.path) && !userId) {
    next('/home')
  } else {
    next()
  }
})

export default router
